// extracted by mini-css-extract-plugin
export default {"root":"InboundProxyRulesTableActions_root__miKMd","action":"InboundProxyRulesTableActions_action__QXM0U","linkAction":"InboundProxyRulesTableActions_linkAction__9mvpk"};